module.exports = __webpack_public_path__ + "img/ERNIE-SLIDER-02.de8c1f7d.jpg";